import * as React from "react";
import { createRoot } from "react-dom/client";

import { FluentProvider } from "@fluentui/react-components";

import App from "./components/App";

import { appTheme } from "./shared/config/theme";
import { AuthProvider, setupAuthInterceptors } from "./features/auth";

setupAuthInterceptors();

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={appTheme}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
